import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

@NgModule({
  imports: [SharedModule, RoutesRoutingModule],
  declarations: [],
})
export class RoutesModule {}
